import axios from 'axios';
import { auth as firebaseAuth } from '../firebase';
import environmentConfig from '../config/environment';

const API_BASE_URL = environmentConfig.getApiBaseUrl();

const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('kanto-token');
  const user = firebaseAuth.currentUser;
  if (user) {
    try {
      token = await user.getIdToken();
      localStorage.setItem('kanto-token', token);
    } catch (e) {
      // Fall back to existing token
    }
  }
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const get = (url, config) => api.get(url, config);
export const postJson = (url, data, config) => api.post(url, data, config);
export const putJson = (url, data, config) => api.put(url, data, config);
export const del = async (url, config) => {
  try {
    return await api.delete(url, config);
  } catch (error) {
    const status = error?.response?.status;
    // Treat 404 as success to make delete idempotent across the app
    if (status === 404) {
      return { data: { success: true } };
    }
    throw error;
  }
};

export default api;


